import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, firstValueFrom } from 'rxjs';
import { EncrdecrService } from './../Auth/encrdecr.service';
import { ConvertToJSONService } from './convert-to-json.service';
const headers = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }
@Injectable({
  providedIn: 'root'
})
export class IPOServiceService {

  ServerUrl = environment.ServerUrl;

  constructor(private http: HttpClient,
    private EncrdecrService: EncrdecrService,
    private jsonParse: ConvertToJSONService) { }
  /*****************Dashboard*************************/
  GetToken() {
    //

    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    console.log("token :: " + token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Basic ${TOKEN}`,
      })
    }
    return tokenOption;
  }
  GetNonJSONToken() {
    //

    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    console.log("token :: " + token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers: new HttpHeaders({
        'Authorization': `Basic ${TOKEN}`,
      })
    }
    return tokenOption;
  }

  getDashboardIPONCDData(body): Observable<any> {
    let url = `${this.ServerUrl}/api/IPOBid/GetIPOData`;
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }
    return this.http.post<any>(url, body, tokenOption);
  }
  getIPOviewmoreData(body): Observable<any> {
    let url = `${this.ServerUrl}/api/IPOBid/GetIPOData`;
    return this.http.post<any>(url, body, this.GetToken());
  }
  getNCDviewmoreData(body): Observable<any> {
    let url = `${this.ServerUrl}/api/IPOBid/GetIPOData`;
    return this.http.post<any>(url, body, this.GetToken());
  }
  OpenFreeAccount(): Observable<any> {
    let url = `https://serviceint.kotaksecurities.in/LMS/AddContactNewBannerLS.aspx?BannerId=236314471642398921&Cmp_BWF_pk=236314471642398921`;
    return this.http.get<any>(url, headers);
  }
  /*****************Dashboard*************************/

  /*****************Current issue*************************/
  getCurrentIssue(): Observable<any> {
    let url = `${this.ServerUrl}/api/IPOReport/Details?status=1&IssueType=I&SubbrokerID=364&TRANS_TYPE=ReportCurrentIPOIssueType`;

    return this.http.get<any>(url, headers);
  }
  getPastIssue(): Observable<any> {
    let url = `${this.ServerUrl}/api/IPOReport/Details?status=0&IssueType=I&SubbrokerID=364&TRANS_TYPE=ReportPastIPOIssueType`;

    return this.http.get<any>(url, headers);
  }
  getNoOfBid(CompanyId, SubbrokerId): Observable<any> {
    let url = `${this.ServerUrl}/api/IPOReport/Details?status=1&COMPANYID=${CompanyId}&SubbrokerID=${SubbrokerId}&TRANS_TYPE=ReportBIDdetails`;

    return this.http.get<any>(url, headers);
  }
  DownloadExcel(CompanyId, SubbrokerId): Observable<any> {
    let url = `${this.ServerUrl}/api/IPOReport/Details?status=1&COMPANYID=${CompanyId}&SubbrokerID=${SubbrokerId}&TRANS_TYPE=ReportBIDdetails`;

    return this.http.get<any>(url, headers);
  }
  ProductNote(CompanyId, SubbrokerId): Observable<any> {
    let DataUrl = `${this.ServerUrl}/api/IPOCompany/Details?COMPANYID=${CompanyId}&TRANS_TYPE=GET_COMPANIES_DETAILS`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.jsonParse.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, headers);
    //return this.http.get<any>(url, headers);
  }
  /*****************Dashboard*************************/

  /*************************ClientList */
  getGroupList(LoginId): Observable<any> {
    // LoginId =364;
    let url = `${this.ServerUrl}/api/IPOExcel/IPOClientMain?GenerateMode=ONLINE&CreatedBy=${LoginId}&TRANS_TYPE=FillGroupDropdown&LoginMode=subbroker`;

    return this.http.get<any>(url, headers);
  }

  getIssueList(issueType): Observable<any> {

    let DataUrl = `${this.ServerUrl}/api/IPOCompany/Details?IssueType=${issueType}&TRANS_TYPE=GET_IPO_NCD_FORM_PRINTING`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.jsonParse.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, headers);
    //   return this.http.get<any>(url, this.GetToken());
  }

  getQuantityAndPrice(companyId): Observable<any> {
    let DataUrl = `${this.ServerUrl}/api/IPOCompany/Details?COMPANYID=${companyId}&TRANS_TYPE=GET_COMPANIES_DETAILS`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.jsonParse.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, headers);
    //return this.http.get<any>(url, headers);

  }
  SearchClient(formData: any): Observable<any> {
    let url = `${this.ServerUrl}/api/IPOExcel/IpoClientList`;

    return this.http.post<any>(url, formData, headers).pipe();
  }

  ValidatePriceAndQty(Qty, SBCode): Observable<any> {
    let loginId = 364
    let IPAddress = "62.171.164.201"
    let CompanyId = 7357;
    let UserName = "VMI359340\Administrator"
    let url = `${this.ServerUrl}/api/IPOExcel/IPOClientMain?TRANS_TYPE=CompanyPriceQuantityValidation&CreatedBy=${loginId}&IPAddress=${IPAddress}&UserName=${UserName}&ApplicationNo=&COMPANY_ID=${CompanyId}&CompanyType=I&Quantity=${Qty}&SrNoList=&GenerateMode=ONLINE&SUBBROKERCODE=${SBCode}&LoginMode=subbroker`

    return this.http.get<any>(url, headers);
  }

  ViewBid(companyId, SubbrokerCode): Observable<any> {
    let url = `${this.ServerUrl}/api/IPOBidData/BSESBidtatus?IssueType=I&TRANS_TYPE=GET_COMPANIES_IPO_NCD_DDL&COMPANY_ID=${companyId}&SUBBROKERCODE=${SubbrokerCode}`
    return this.http.get<any>(url, this.GetToken());
  }

  InitiateBid(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/IPOExcel/IPOGeneratePDFDetails`

    return this.http.post<any>(url, formData, headers).pipe();
  }

  /******************************* */


  GetBankList(): Observable<any> {
    let url = `${this.ServerUrl}/api/Bank/Details`

    return this.http.get<any>(url, headers);
  }
  GetLocationList(): Observable<any> {
    let url = `${this.ServerUrl}/api/IPOLocation/Details`

    return this.http.get<any>(url, headers);
  }
  ValidateUPIId(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/IPOBid/GET_IPO_Bidding_Data`;
    return this.http.post<any>(url, formData, this.GetToken()).pipe();
  }

  PostClient(formData): Observable<any> {
    debugger
    let url = `${this.ServerUrl}/api/IPOClientBankDetail/SaveNdUpdateIPOClientBankDetails`
    return this.http.post<any>(url, formData, headers).pipe();
  }

  DeleteUPI(SrNo, TRANS_TYPE): Observable<any> {
    let url = `${this.ServerUrl}/api/IPOClientDetails/DeleteUPI`;
    let request: any = {
      "SrNo": SrNo,
      "TRANS_TYPE": TRANS_TYPE,
    };
    request = JSON.stringify(request);
    return this.http.post<any>(url, request, this.GetToken()).pipe();
  }


  //****************AllotementReport */
  GetIssueByFinacialYear(IssueType: any, FinancialYear: any): Observable<any> {
    let DataUrl = `${this.ServerUrl}/api/IPOCompany/Details?IssueType=${IssueType}&FinancialYear=${FinancialYear}&TRANS_TYPE=GET_COMPANIES_IPO_NCD_DDL`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.jsonParse.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, this.GetToken());
    //  return this.http.get<any>(url, this.GetToken());
  }

  GetIPONCDSearchList(body): Observable<any> {
    let url = `${this.ServerUrl}/api/IPOBid/GetIPOData`;
    return this.http.post<any>(url, body, this.GetToken());
  }

  GetBidStatusList(CompanyId: any, subbrokercode: any, IssueType: any): Observable<any> {
    let url = `${this.ServerUrl}/api/IPOBidData/BSESBidtatus?TRANS_TYPE=GET_COMPANIES_IPO_NCD_DDL&COMPANY_ID=${CompanyId}&SUB_BROKER_CODE=${subbrokercode}&IssueType=${IssueType}`;

    return this.http.get<any>(url, this.GetToken());
  }

  AllotmentReport(data): Observable<any> {
    let url = `${this.ServerUrl}/api/IPOReport/GetAllotmentReportDetails`;
    return this.http.post<any>(url, data, this.GetToken());
  }

// Comented By Sourabh 
  // GetIPOCompanyDetails(data: any): Observable<any> {
  //   let url = `${this.ServerUrl}/api/IPOCompanyDetails/GetIPOCompanyDetails`
  //   //return this.http.post<any>(data,url).pipe();
  //   let request = { data: this.EncrdecrService.setEncr(JSON.stringify(data)) }
  //   return this.http.post(url, request).pipe();
  // }
  // Added By Sourabh 
    GetIPOCompanyDetails(data: any): Observable<any> {
    let url = `${this.ServerUrl}/api/IPOCompanyDetails/GetIPOCompanyDetails`
    
        return this.http.post(url,data, this.GetToken()).pipe();
  }
  GetRHPDocumentDetails(data: any): Observable<any> {
    let url = `${this.ServerUrl}/api/IPOCompanyDetails/GetRHPDocumentDetails`
    return this.http.post<any>(url, data, headers).pipe();
  }
  GetIPOClientDetails(FirstApplicantPAN, SubBrokerCode, EmpCode, ClientCode): Observable<any> {
    let url = `${this.ServerUrl}/api/IPOClientDetails/GetIPOClientDetails`;
    let request: any = {
      "ClientCode": ClientCode,
      "FirstApplicantPAN": FirstApplicantPAN,
      "SubBrokerCode": SubBrokerCode,
      "EmpCode": EmpCode
    };
    request = JSON.stringify(request);
    let inputdata: any = {
      data: this.EncrdecrService.setEncr(request)
    }
    return this.http.post<any>(url, inputdata).pipe();
  }
  async GetClientIPOSrNoByClientId(ClientBasicInfoId: string) {
debugger
    let DataUrl = `${this.ServerUrl}/api/DropDown/Details?TRANS_TYPE=GetIPOClientByClientID&REFF_ID=${ClientBasicInfoId}`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.jsonParse.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body, this.GetToken()).pipe();
    const result = await this.postAPICall(body, "/api/DropDown/Details", this.GetToken());
    return result;

  }
  GET_IPO_Bidding_Data(UPIId): Observable<any> {
    let url = `${this.ServerUrl}/api/DropDownIPO/FillDetails?TRANS_TYPE=UPIValidation&REFF_ID=${UPIId}&REFF_ID2&REFF_ID3&CON_STR=IPO`;
    const json = this.jsonParse.QueryStringToJSONWithEncryptedValue(url.split('?')[1]);

    return this.http.post<any>(url.split('?')[0], json).pipe();
  }
  SaveNdUpdateIPOClientBankDetails(formData): Observable<any> {
    // let url = `${this.ServerUrl}api/IPOClientBankDetail/SaveNdUpdateIPOClientBankDetails?SrNo=${SrNo}&FirstApplicant=${FirstApplicant}&FirstApplicantPAN=${FirstApplicantPAN}&Mobile=${Mobile}&Email=${Email}&CreatedBy=${CreatedBy}&Status=${Status}&Address=${Address}&Pincode=${Pincode}&IPAddress=${IPAddress}&Subbrokercode=${Subbrokercode} &EmpCode=${EmpCode}&Group=${Group}`
    let url = `${this.ServerUrl}/api/IPOClientBankDetail/SaveNdUpdateIPOClientBankDetails`;
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(formData)) }
    return this.http.post<any>(url, request, this.GetToken()).pipe();
  }
  IPONCDBiding(formData, flag): Observable<any> {
    let url = `${this.ServerUrl}/api/IPONCDBiding/${flag}Details`
    return this.http.post<any>(url, formData).pipe();
  }
  IPONCDOrderStatus(formData): Observable<any> {
    let url = `${this.ServerUrl}/api/IPONCDOrderStatus/OrderStatus`
    return this.http.post<any>(url, formData).pipe();
  }
  GetBidData(CompanyId, SubBrokerCode, EmpCode, PanNo): any {
    const url = `${this.ServerUrl}/api/IPOBidData/BSESBidtatus?COMPANY_ID=${CompanyId}&SUB_BROKER_CODE=${SubBrokerCode}&EmpCode=${EmpCode}&PANNo=${PanNo}`;
    const json = this.jsonParse.QueryStringToJSONWithEncryptedValue(url.split('?')[1]);
    return this.http.post(url.split('?')[0], json, this.GetToken());
  }
  GetIPOCompanyList(IssueType): any {
    const url = `${this.ServerUrl}/api/DropDownIPO/FillDetails?TRANS_TYPE=ALLIPONCD&REFF_ID=${IssueType}&REFF_ID2&REFF_ID3&CON_STR=IPO`;
    const json = this.jsonParse.QueryStringToJSONWithEncryptedValue(url.split('?')[1]);
    return this.http.post(url.split('?')[0], json, this.GetToken());
  }
//Commented By Sourabh 
  // GetOrderBookReport(data): Observable<any> {
  //   let url = `${this.ServerUrl}/api/IPOBid/IPOTradeOrderBook`;
  //   return this.http.post<any>(url, data, this.GetToken());
  // }

  // Added By Sourabh 
  GetOrderBookReport(data): Observable<any> {
    let url = `${this.ServerUrl}/api/IPOBid/IPOTradeOrderBook`;
    return this.http.post<any>(url, data, this.GetToken());
  }

  GetIPOCompanylistDetails(IssueType: any): Observable<any> {
    let s_url = `${this.ServerUrl}/api/DropDownIPO/FillDetails?TRANS_TYPE=ALLIPONCD&REFF_ID=${IssueType}&REFF_ID2&REFF_ID3&CON_STR=IPO`
    const url = s_url.split('?')[0];
    const QueryString = s_url.split('?')[1];
    const body = this.jsonParse.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, this.GetToken()).pipe();
  }
  GetClients(SubBrokerCode: any, EmpCode): Observable<any> {
    let s_url = `${this.ServerUrl}/api/DropDownIPO/FillDetails?TRANS_TYPE=GET_IPO_NCD_CLIENTS&REFF_ID=${SubBrokerCode}&REFF_ID2=${EmpCode}&REFF_ID3&CON_STR=IPO`
    const url = s_url.split('?')[0];
    const QueryString = s_url.split('?')[1];
    const body = this.jsonParse.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, this.GetToken()).pipe();
  }
  GetClientDetails(ClientID: any): Observable<any> {
    let s_url = `${this.ServerUrl}/api/DropDownIPO/FillDetails?TRANS_TYPE=GET_IPO_NCD_CLIENT_DETAILS&REFF_ID=${ClientID}&CON_STR=IPO`
    const url = s_url.split('?')[0];
    const QueryString = s_url.split('?')[1];
    const body = this.jsonParse.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, this.GetToken()).pipe();
  }
  GetTradeBookReport(Subbrokercode: any, CompanyId: any, ApplicationNo: any, PANNO: any, CStatus: any, EmpCode: any): Observable<any> {
    let url = `${this.ServerUrl}/api/IPOBid/IPOTradeOrderBook?Flag=TradeBook&COMPANY_ID=${CompanyId}&SUBBROKER_CODE=${Subbrokercode}&ApplicationNo=${ApplicationNo}&CStatus=${CStatus}&EmpCode=${EmpCode}&OrderNo=${PANNO}`;

    return this.http.get<any>(url, this.GetToken());
  }
  GetNCDSeries(CompId): Observable<any> {
    let url = `${this.ServerUrl}/api/DropDownIPO/FillDetailsIPO?TRANS_TYPE=NCDSERIES&REFF_ID=${CompId}&REFF_ID2&REFF_ID3&CON_STR=IPO`
    const json = this.jsonParse.QueryStringToJSONWithEncryptedValue(url.split('?')[1])
    return this.http.post<any>(url.split('?')[0], json, this.GetToken()).pipe();
  }
  GetDropdownDetails(flag: any): Observable<any> {
    let s_url = `${this.ServerUrl}/api/DropDownIPO/FillDetails?TRANS_TYPE=${flag}&REFF_ID&REFF_ID2&REFF_ID3&CON_STR=IPO`
    const url = s_url.split('?')[0];
    const QueryString = s_url.split('?')[1];
    const body = this.jsonParse.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body).pipe();

  }
  GetDropdowndynamicDetails(flag: any, refid: any, refid2: any, refid3: any): Observable<any> {
    let s_url = `${this.ServerUrl}/api/DropDownIPO/FillDetails?TRANS_TYPE=${flag}&REFF_ID=${refid}&REFF_ID2=${refid2}&REFF_ID3=${refid3}&CON_STR=IPO`
    const url = s_url.split('?')[0];
    const QueryString = s_url.split('?')[1];
    const body = this.jsonParse.QueryStringToJSONWithEncryptedValue(QueryString);
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }
    return this.http.post<any>(url, body, tokenOption).pipe();

  }
  IPOClientList(formData: any): Observable<any> {

    let url = `${this.ServerUrl}/api/IPONCDConsent/IPOClientList`;

    return this.http.post<any>(url, formData, headers).pipe();
  }
  InitiateBidNEW(formData): Observable<any> {

    let url = `${this.ServerUrl}/api/IPONCDConsent/IPOinitiateBid`

    return this.http.post<any>(url, formData, headers).pipe();
  }
  GetIPOBankList(): Observable<any> {
    let url = `${this.ServerUrl}/api/DropDownIPO/FillDetails?TRANS_TYPE=ASBABANK&REFF_ID&REFF_ID2&REFF_ID3&CON_STR=IPO`
    const json = this.jsonParse.QueryStringToJSONWithEncryptedValue(url.split('?')[1])
    return this.http.post<any>(url.split('?')[0], json, this.GetToken()).pipe();
  }
  GetIPOBankLocation(): Observable<any> {
    let url = `${this.ServerUrl}/api/DropDownIPO/FillDetails?TRANS_TYPE=ASBALOCATION&REFF_ID&REFF_ID2&REFF_ID3&CON_STR=IPO`
    const json = this.jsonParse.QueryStringToJSONWithEncryptedValue(url.split('?')[1])
    return this.http.post<any>(url.split('?')[0], json, this.GetToken()).pipe();
  }
  GetDetailsFromApplicationNo(CompId, ApplicationNo): Observable<any> {
    let url = `${this.ServerUrl}/api/IPOBid/IPONCDApplication?COMPANY_ID=${CompId}&ApplicationNo=${ApplicationNo}`
    const json = this.jsonParse.QueryStringToJSON(url.split('?')[1])
    return this.http.post<any>(url.split('?')[0], json, this.GetToken()).pipe();
  }
  CheckValidUPIId(UPIID): Observable<any> {
    let url = `${this.ServerUrl}/api/DropDownIPO/FillDetails?TRANS_TYPE=UPIValidation&REFF_ID=${UPIID}&REFF_ID2&REFF_ID3&CON_STR=IPO`
    const json = this.jsonParse.QueryStringToJSONWithEncryptedValue(url.split('?')[1])
    return this.http.post<any>(url.split('?')[0], json, this.GetToken()).pipe();
  }
  CheckExistApplication(applicationno, compid): Observable<any> {
    let url = `${this.ServerUrl}/api/DropDownIPO/FillDetails?TRANS_TYPE=APPLICATIONExist&REFF_ID=${applicationno}&REFF_ID2=${compid}&REFF_ID3&CON_STR=IPO`
    const json = this.jsonParse.QueryStringToJSONWithEncryptedValue(url.split('?')[1])
    return this.http.post<any>(url.split('?')[0], json, this.GetToken()).pipe();
  }
  IPOFillDetails(applicationno, compid, Flag): Observable<any> {
    let url = `${this.ServerUrl}/api/DropDownIPO/FillDetails?TRANS_TYPE=${Flag}&REFF_ID=${compid}&REFF_ID2=&REFF_ID3&CON_STR=IPO`
    const json = this.jsonParse.QueryStringToJSONWithEncryptedValue(url.split('?')[1]);
    return this.http.post<any>(url.split('?')[0], json).pipe();
  }

  SendIPOConsentApplication(data: any): Observable<any> {
    const url = `${this.ServerUrl}/api/IPONCDConsent/ConsentApplicationDetails`;
    return this.http.post<any>(url, data, headers);
  }

  GeneratePDFForm(data: any): Observable<any> {
    const url = `${this.ServerUrl}/api/IPONCDConsent/IPOinitiateBid`;
    return this.http.post<any>(url, data, headers);
  }
  GenerateMobileOTP(DataBody): Observable<any> {
    const url = `${this.ServerUrl}/api/SendSMSNDMAIL/SendSMS`;
    return this.http.post<any>(url, DataBody, headers);
  }

  GenerateMobileOTPJM(DataBody): Observable<any> {
    const url = `${this.ServerUrl}/api/CommonOTP/SendOTPSMSJM`;
    return this.http.post<any>(url, DataBody, headers);
  }
  GetSSOClient(DataBody): Observable<any> {
    const url = `${this.ServerUrl}/api/Authenticate/GetSSOClientDetails`;
    return this.http.post<any>(url, DataBody, headers);
  }
  GetSSOClientNEO(DataBody): Observable<any> {
    const url = `${this.ServerUrl}/api/Authenticate/GetNEOSSOClientDetails`;
    return this.http.post<any>(url, DataBody, headers);
  }
  GetIPONCDClientSearch(data: any): Observable<any> {
    const url = `${this.ServerUrl}/api/IPONCDClientSearch/ClientList`;
    return this.http.post<any>(url, data, this.GetToken());
  }
  GetFinancialYear(data) {
    const url = `${this.ServerUrl}/api/DropDownIPO/FillDetails`;
    return this.http.post<any>(url, data, this.GetToken());
  }
  PostASBAOrder(data) {
    const url = `${this.ServerUrl}/api/IPONCDBiding/IPOASBADetails`;
    return this.http.post<any>(url, data, this.GetToken());
  }
  GetValidateUPI_SSO(data) {
    const url = `${this.ServerUrl}/api/Authenticate/GetUPIDetails`;
    return this.http.post<any>(url, data, headers);
  }
  ClientBulkUpload(data: any) {
    const url = `${this.ServerUrl}/api/IPOExcel/ClientBulkUploadIpo`;//ClientBulkUpload
    return this.http.post<any>(url, data, this.GetNonJSONToken());
  }
  GetValidInvalidData(SubBrokerId, Flag) {
    const DataUrl = `${this.ServerUrl}/api/IPOExcel/GetIPOTempClientDetails?Created_By=${SubBrokerId}&TRANS_TYPE=${Flag}`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.jsonParse.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, this.GetNonJSONToken()).pipe();
    // return this.http.get<any>(url, this.GetNonJSONToken());
  }
  SaveValidClientData(data: any) {
    const url = `${this.ServerUrl}/api/IPOExcel/SaveValidData`;
    return this.http.post<any>(url, data, this.GetNonJSONToken());
  }
  GetAllClients(data: any) {
    const url = `${this.ServerUrl}/api/IPOExcel/GetAllClient`;
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(data)) }
    return this.http.post<any>(url, request, this.GetNonJSONToken());
  }
  BindNCDSeries(CompanyID: any): Observable<any> {
    let DataUrl = `${this.ServerUrl}/api/IPOCompany/Details?COMPANYID=${CompanyID}&TRANS_TYPE=GET_NCD_SERIES`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.jsonParse.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body);
    //  return this.http.get<any>(url, this.GetToken());
  }

  SaveNdUpdateIPOClientBankDetailsWithoutToken(formData): Observable<any> {
    // let url = `${this.ServerUrl}api/IPOClientBankDetail/SaveNdUpdateIPOClientBankDetails?SrNo=${SrNo}&FirstApplicant=${FirstApplicant}&FirstApplicantPAN=${FirstApplicantPAN}&Mobile=${Mobile}&Email=${Email}&CreatedBy=${CreatedBy}&Status=${Status}&Address=${Address}&Pincode=${Pincode}&IPAddress=${IPAddress}&Subbrokercode=${Subbrokercode} &EmpCode=${EmpCode}&Group=${Group}`
    let url = `${this.ServerUrl}/api/IPOClientBankDetail/SaveNdUpdateIPOClientBankDetailsWithoutToken`;
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(formData)) }
    return this.http.post<any>(url, request, headers).pipe();
  }

  async GetSubBrokerNameByID(SB_ID: any) {
    const DataUrl = `${this.ServerUrl}/api/DropDown/Details?TRANS_TYPE=GetSBNameByID&REFF_ID=${SB_ID}&CON_STR=SMC`;
    // return this.http.get<any>(url,this.GetToken());
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.jsonParse.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body).pipe();
    const result = await this.postAPICall(body, "/api/DropDown/Details", {});
    return result;
  }

  BindNCDList(): Observable<any> {
    let url = `${this.ServerUrl}/api/DropDownIPO/FillDetails?TRANS_TYPE=GetNCDCompanyList&CON_STR=IPO`
    const json = this.jsonParse.QueryStringToJSONWithEncryptedValue(url.split('?')[1])
    return this.http.post<any>(url.split('?')[0], json, this.GetToken()).pipe();
  }

  GetNCDTallySheetData(formData): Observable<any> {

    let url = `${this.ServerUrl}/api/IPONCDBiding/GetNCDTallySheetData`;
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(formData)) }
    return this.http.post<any>(url, request, this.GetToken()).pipe();
  }

  GetBankCoveringLetterData(formData): Observable<any> {

    let url = `${this.ServerUrl}/api/IPONCDBiding/GetNCDBankCoveringLetterData`;
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(formData)) }
    return this.http.post<any>(url, request, this.GetToken()).pipe();
  }

  StoreFileAndGenerateZip(formData): Observable<any> {

    let url = `${this.ServerUrl}/api/IPONCDBiding/StoreFileAndGenerateZip`;
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(formData)) }
    return this.http.post<any>(url, request, this.GetToken()).pipe();
  }

  // Added By Sourabh On 01072026

   VideoShowService(): Observable<any> {//
    ;
    let url = `${this.ServerUrl}api/VideoShow/ListShow`;
    return this.http.post<any>(url, this.GetToken());
  }
   checkiponcdClosedOrNot(data:any): Observable<any>{
    let url = `${this.ServerUrl}/api/IPOCompanyDetails/checkiponcdClosedOrNot`
     return this.http.post(url,data, this.GetToken()).pipe();
  }
  getDashboardIPONCDData1(body): Observable<any> {
    
    let url = `${this.ServerUrl}/api/IPOBid/GetIPOData`;
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }
    return this.http.post<any>(url, body, tokenOption);
  }
   GetOrderBookReport1(data): Observable<any> {
    ;
    let url = `${this.ServerUrl}/api/IPOBid/IPOTradeOrderBook1`;
    return this.http.post<any>(url, data, this.GetToken());
  }

  async postAPICall(Request: any, URL: any, headersdy = {}): Promise<any> {
    let Url = `${this.ServerUrl}${URL}`;

    let KeyPair = await this.EncrdecrService.getKeyPair();
    Request.publicKey = KeyPair.publicKeySpkiBase64;

    let EncryptedData = await this.EncrdecrService.encryptJson(Request, environment.RSA_PUBLIC_KEY_BASE64);

    let body = {
      "EncryptedData": EncryptedData.encryptedData,
      "dvfv": EncryptedData.encryptedKey,
      "sdcsd": EncryptedData.iv
    };
    if (!headersdy) {
      headersdy = headers
    }
    const response = await firstValueFrom(this.http.post<any>(Url, body, headersdy));

    const DecryptedResponse = this.EncrdecrService.decryptResponse(
      response.EncryptedDataBase64,
      response.EncryptedAesKeyBase64,
      response.IvBase64,
      KeyPair.privateKeyPem
    );

    return DecryptedResponse;
  }
}
